import { useAuthContext } from '@/components/AuthContext';
import { env } from '@/config/env';
import { ApiError } from '@/lib/api/ApiError';
import BillingApiSdk, { ClientInferRequest, contract } from '@pie/billing-api-sdk';
import { useQueries, useQuery } from '@tanstack/react-query';

const { client } = new BillingApiSdk({ environment: env.NEXT_PUBLIC_PIE_ENV });

const getPaymentPlan = async (
  policyId: string,
  extraHeaders: ClientInferRequest<typeof contract.getPaymentPlan>['extraHeaders']
) => {
  const response = await client.getPaymentPlan({
    extraHeaders,
    params: { policyId },
  });

  if (response.status !== 200) {
    throw new ApiError(response.status, response.body, response.headers);
  }

  return {
    ...response.body,
    // TODO: this should be in the response
    policyId,
  };
};

export const usePolicyPaymentPlan = (policyId: string) => {
  const { getSessionHeaders } = useAuthContext();

  return useQuery({
    queryKey: ['billingApiSdk', 'getPaymentPlan', policyId],
    queryFn: async () => {
      const { authorization } = await getSessionHeaders();
      return getPaymentPlan(policyId, { authorization });
    },
  });
};

// TODO: this is an N+1 that needs to be moved to the server as list endpoint
export const usePolicyPaymentPlans = (policyIds: string[]) => {
  const { getSessionHeaders } = useAuthContext();

  return useQueries({
    queries: policyIds.map((policyId) => ({
      queryKey: ['billingApiSdk', 'getPaymentPlan', policyId],
      queryFn: async () => {
        const { authorization } = await getSessionHeaders();
        return getPaymentPlan(policyId, { authorization });
      },
    })),
  });
};
